<template>
  <div class="case-list-container">
    <!-- 查询筛选组件框 -->
    <div class="filter-box">
      <el-card class="box-card">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="案件状态">
            <el-select
              v-model="searchForm.case_status"
              placeholder="请选择案件状态"
              clearable
              style="width: 150px;"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="立案类型">
            <el-select
              v-model="searchForm.sue_type"
              placeholder="请选择立案类型"
              clearable
              style="width: 150px;"
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="0" label="立案"></el-option>
              <el-option value="1" label="调解"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="资料状态">
            <el-select
              v-model="searchForm.is_complete"
              placeholder="请选择资料状态"
              clearable
              style="width: 150px;"
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="1" label="资料完整"></el-option>
              <el-option value="0" label="资料待完善"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 统计面板 -->
    <div class="statistics-panel">
      <el-card class="box-card">
        <div class="statistic-row">
          <div class="statistic-label-title">本月量</div>
          <div class="statistic-main">
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.count }}</div>
              <div class="statistic-label">计划立案量</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.not_submitted }}</div>
              <div class="statistic-label">未提交</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.submitted }}</div>
              <div class="statistic-label">已提交</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.mediation }}</div>
              <div class="statistic-label">调解</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.filed }}</div>
              <div class="statistic-label">已立案</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.executing }}</div>
              <div class="statistic-label">案件执行</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.third_party }}</div>
              <div class="statistic-label">第三方</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.closed }}</div>
              <div class="statistic-label">已结案</div>
            </div>
          </div>
          <div class="statistic-divider"></div>
          <div class="statistic-complete">
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.complete_count }}</div>
              <div class="statistic-label">已完善</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.month.incomplete_count }}</div>
              <div class="statistic-label">未完善</div>
            </div>
          </div>
        </div>
        <div class="statistic-row">
          <div class="statistic-label-title total">累计量</div>
          <div class="statistic-main">
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.count }}</div>
              <div class="statistic-label">计划立案量</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.not_submitted }}</div>
              <div class="statistic-label">未提交</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.submitted }}</div>
              <div class="statistic-label">已提交</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.mediation }}</div>
              <div class="statistic-label">调解</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.filed }}</div>
              <div class="statistic-label">已立案</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.executing }}</div>
              <div class="statistic-label">案件执行</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.third_party }}</div>
              <div class="statistic-label">第三方</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.closed }}</div>
              <div class="statistic-label">已结案</div>
            </div>
          </div>
          <div class="statistic-divider"></div>
          <div class="statistic-complete">
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.complete_count }}</div>
              <div class="statistic-label">已完善</div>
            </div>
            <div class="statistic-item">
              <div class="statistic-number">{{ statics.total.incomplete_count }}</div>
              <div class="statistic-label">未完善</div>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 操作按钮区域 -->
    <div class="operation-box">
      <el-card class="box-card">
        <div class="operation-inline-container">
          <span class="inline-group-label">案件管理：</span>
          <el-button type="default" size="small" @click="batchOperation('file')" :disabled="!canOperate">资料盖章</el-button>
          <el-button type="default" size="small" @click="batchOperation('submit_court')" :disabled="!canOperate">提交法院</el-button>
          <el-button type="default" size="small" @click="batchOperation('mediation')" :disabled="!canOperate">调解过程</el-button>
          <el-button type="default" size="small" @click="batchOperation('accept')" :disabled="!canOperate">受理成功</el-button>
          <el-button type="default" size="small" @click="batchOperation('reject')" :disabled="!canOperate">拒绝受理</el-button>
          <el-button type="default" size="small" @click="batchOperation('fill')" :disabled="!canOperate">诉讼费用</el-button>
          <el-button type="default" size="small" @click="batchOperation('preservation')" :disabled="!canOperate">诉讼保全</el-button>
          <el-button type="default" size="small" @click="batchOperation('court')" :disabled="!canOperate">开庭记录</el-button>
          <el-button type="default" size="small" @click="batchOperation('discount')" :disabled="!canOperate">折扣申请</el-button>
          <el-button type="default" size="small" @click="batchOperation('appeal')" :disabled="!canOperate">上诉申请</el-button>
          <el-button type="default" size="small" @click="batchOperation('execute')" :disabled="!canOperate">案件执行</el-button>
          <el-button type="default" size="small" @click="batchOperation('close')" :disabled="!canOperate">回款结案</el-button>

          <!-- 右侧悬浮：选择信息提示 -->
          <div class="selection-info-inline" v-if="multipleSelection.length > 0">
            已选择 <span class="selection-count">{{ multipleSelection.length }}</span> 条
            <el-button type="text" size="small" @click="clearSelection" style="margin-left: 5px; padding: 0;">取消</el-button>
          </div>
        </div>
        <div>
          <el-button type="primary" size="small" @click="showPic.visible = true" style="margin-left: 20px;">案件处理过程</el-button>
        </div>
      </el-card>
    </div>

    <!-- 案件表格 -->
    <div class="table-box">
      <el-card class="box-card">
        <el-table
          :data="tableData"
          v-loading="loading"
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
        >
          <el-table-column type="selection" width="55" :selectable="canSelectRow"></el-table-column>
          <el-table-column prop="project.name" label="所在项目" width="200"></el-table-column>
          <el-table-column prop="agreement.HouseName" label="房产" width="200"></el-table-column>
          <el-table-column prop="court.name" label="法院" width="200"></el-table-column>
          <el-table-column prop="plaintiff" label="原告" width="120"></el-table-column>
          <el-table-column prop="defendant" label="被告" width="120"></el-table-column>
          <el-table-column prop="legal_money" label="案件金额" width="120">
            <template slot-scope="scope">
              ¥{{ scope.row.legal_money || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="plan_month" label="催费月份" width="120"></el-table-column>
          <el-table-column label="资料状态" width="120">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.is_complete ? 'success' : 'warning'"
                size="small">
                {{ scope.row.is_complete ? '已完善' : '待完善' }}
              </el-tag>
              <el-link
                v-if="!scope.row.is_complete"
                type="primary"
                @click="showFileDetail(scope.row)"
                style="margin-left: 8px;">
                完善
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="案件状态" width="120">
            <template slot-scope="scope">
              <el-tag :type="getStageType(scope.row.case_status)" size="small">
                {{ getStageLabel(scope.row.case_status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="pay_money" label="执行金额" width="120">
            <template slot-scope="scope">
              ¥{{ scope.row.pay_money || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
          <el-table-column label="操作" fixed="right" width="120">
            <template slot-scope="scope">
              <el-link @click="viewCase(scope.row)">详情</el-link>
              <el-link @click="showFileDetail(scope.row)" style="margin-left: 10px;">资料</el-link>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 流程处理弹窗 -->
    <case-flow ref="caseFlow" @close="onCloseCaseFlow" :case_list="multipleSelection"
               :visible="flow.dialog.visible" :title="flow.dialog.title" :type="flow.dialog.type" :project_type="project_type"/>

    <!-- 费用申请弹窗 -->
    <case-fill ref="caseFill" @close="onCloseCaseFill" :case_list="multipleSelection"
               :visible="fill.dialog.visible" :title="fill.dialog.title" :data_type="fill.dialog.type" :project_type="project_type.toString()"/>

    <!-- 案件执行弹窗 -->
    <case-pay ref="casePay" @close="onCloseCasePay" :case_list="multipleSelection" :project_type="project_type"
              :visible="pay.dialog.visible" :title="pay.dialog.title" :data_type="pay.dialog.type" />

    <!-- 案件详情弹窗 -->
    <case-detail :visible="detail.visible" :case-id="detail.case_id" @close="onCloseDetail" />

    <!-- 文件详情弹窗 -->
    <el-dialog title="案件资料完善" :visible.sync="fileDetailDialog.visible" width="80%" @close="loadData">
      <CaseFileForm v-if="fileDetailDialog.visible" :caseItem="fileDetailDialog.caseItem" @close="onCloseFileDetail"/>
    </el-dialog>

    <!-- 通用操作弹窗 -->
    <el-dialog :title="operationDialog.title" :visible.sync="operationDialog.visible" width="80%">
      <el-form>
        <!-- 伸缩面板 - 支持单案件和多案件 -->
        <el-collapse v-model="operationActiveNames">
          <el-collapse-item
            :title="`案件: ${caseItem.defendant} - ${  (caseItem.agreement && caseItem.agreement.HouseName) || ''}`"
            :name="index"
            v-for="(caseItem, index) in operationCaseList"
            :key="caseItem.id || index">
            <el-form :model="caseItem" :ref="`operationForm_${index}`">
              <el-form-item label="时间">
                <el-date-picker
                  v-model="caseItem.operation_time"
                  type="date"
                  placeholder="选择时间"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="跟进人">
                <el-input v-model="caseItem.follow_user" placeholder="请输入跟进人"></el-input>
              </el-form-item>
              <el-form-item label="案号/编号" v-if="operationDialog.type === 'accept'" required>
                <el-input v-model="caseItem.case_no" placeholder="请输入受理案号"></el-input>
              </el-form-item>
              <!-- 提交法院特殊字段 -->
              <el-form-item label="管辖法院/仲裁委" v-if="operationDialog.type === 'submit_court'">
                <el-select v-model="caseItem.court_id" placeholder="请选择管辖法院/仲裁委">
                  <el-option v-for="item in court_list" :key="item.court_id" :value="item.court_id" :label="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="诉讼请求" v-if="operationDialog.type === 'submit_court'">
                <el-input
                  v-model="caseItem.claims"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入诉讼请求"
                  size="small"
                />
              </el-form-item>
              <el-form-item label="折扣比例" v-if="operationDialog.type === 'discount'">
                <el-input
                  v-model="caseItem.discount_rate"
                  type="number"
                  placeholder="请输入折扣比例(0-100)"
                  :min="0"
                  :max="100"
                  style="width: 200px;"
                />
                <span style="margin-left: 10px;">%</span>
              </el-form-item>
              <el-form-item label="执行金额" v-if="operationDialog.type === 'close'">
                <el-input
                  v-model="caseItem.pay_money"
                  type="number"
                  disabled="true"
                  style="width: 200px;"
                />
              </el-form-item>
              <el-form-item label="回款金额" v-if="operationDialog.type === 'close'">
                <el-input
                  v-model="caseItem.close_money"
                  type="number" style="width: 200px;"
                />
              </el-form-item>
              <el-form-item label="执行结果" v-if="operationDialog.type === 'close'">
              <el-select v-model="caseItem.execute_result" placeholder="请选择执行结果">
                <el-option :value="'success'" label="执行成功"></el-option>
                <el-option :value="'partial'" label="部分执行"></el-option>
                <el-option :value="'failed'" label="执行失败"></el-option>
                <el-option :value="'pending'" label="执行中"></el-option>
              </el-select>
              </el-form-item>
              <el-form-item label="回款方式" v-if="operationDialog.type === 'close'">
              <el-select v-model="caseItem.pay_method" placeholder="请选择回款方式">
                <el-option :value="'cash'" label="现金"></el-option>
                <el-option :value="'bank'" label="银行转账"></el-option>
                <el-option :value="'wechat'" label="微信"></el-option>
                <el-option :value="'alipay'" label="支付宝"></el-option>
                <el-option :value="'other'" label="其他"></el-option>
              </el-select>
              </el-form-item>
              <el-form-item label="证明文件" :required="operationDialog.type === 'accept'">
                <el-upload
                  :http-request="(param) => handleCaseUpload(param, caseItem, getFileKey())"
                  action=""
                  :show-file-list="false"
                  multiple
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <div v-if="caseItem.file_list && caseItem.file_list.length > 0">
                  <el-tag
                    v-for="(file, fileIndex) in caseItem.file_list"
                    :key="fileIndex"
                    size="small"
                    closable
                    @close="removeCaseFile(caseItem, fileIndex)">
                    {{ file.file_name }}
                  </el-tag>
                </div>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="caseItem.remark" type="textarea" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="operationDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitOperation" :loading="operationLoading">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showPic.visible" @close="showPic.visible = false">
      <div style="text-align: center;">
        <img :src="'/static/staging/case_flow.png'" style="max-width: 100%; cursor: pointer;" @click="openImageInNewTab" />
        <p style="color: #909399; margin-top: 10px;">点击图片可在新标签页打开</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import caseJs from './case.js';
import CaseFlow from './case_flow.vue';
import CaseFill from './case_fill.vue';
import CasePay from './case_pay.vue';
import CaseDetail from './case_detail.vue';
import CaseFileForm from './case_file_form.vue';

export default {
  name: 'CaseList',
  components: {
    CaseFlow, CaseFill, CasePay, CaseDetail, CaseFileForm
  },
  inject: ['where', 'reginWhere'],
  data() {
    return {
      loading: false,
      operationLoading: false,
      multipleSelection: [],
      searchForm: {
        case_status: '',
        sue_type: '',
        is_complete: ''
      },
      statusOptions: [
        { value: '', label: '全部' },
        { value: '0', label: '未提交立案' },
        { value: '1', label: '已提交' },
        { value: '2', label: '已调解' },
        { value: '3', label: '已立案' },
        { value: '4', label: '已结案' },
        { value: '5', label: '转到第三方' }
      ],
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      statics: {
        month: {
          count: 0,
          not_submitted: 0,
          submitted: 0,
          filed: 0,
          mediation: 0,
          executing: 0,
          third_party: 0,
          closed: 0,
          complete_count: 0,
          incomplete_count: 0,
        },
        total: {
          count: 0,
          not_submitted: 0,
          submitted: 0,
          filed: 0,
          mediation: 0,
          executing: 0,
          third_party: 0,
          closed: 0,
          complete_count: 0,
          incomplete_count: 0,
        },
      },
      court_list: [], // 法院列表
      flow: {
        dialog: { visible: false, title: '', type: '' },
      },
      fill: {
        dialog: { visible: false, title: '费用申请', type: '' },
      },
      pay: {
        dialog: { visible: false, title: '案件执行', type: '' },
      },
      detail: {
        visible: false,
        case_id: 0,
      },
      fileDetailDialog: {
        visible: false,
        caseItem: null,
      },
      operationDialog: {
        visible: false,
        title: '',
        type: ''
      },
      operationActiveNames: [],          // 伸缩面板激活状态
      operationCaseList: [],              // 操作案件数据列表
      project_type : 1,   // 项目类型：1 在管；2撤场
      showPic : {
        visible: false,
      },
    }
  },
  computed: {
    canOperate() {
      if (this.multipleSelection.length === 0) return false;
      return this.multipleSelection.every(item => item.is_complete);
    }
  },
  created() {
    this.loadData();
  },
  watch: {
    "reginWhere": {
      handler: function (n, o) {
        this.onSearch();
      },
      deep: true
    },
    "where": {
      handler: function (n, o) {
        this.onSearch();
      },
      deep: true
    }
  },
  methods: {
    loadData() {
      if(this.reginWhere.type_id == 4 || this.reginWhere.type_id == 3){
        this.project_type = 2;  // 撤场项目
      }else{
        this.project_type = 1;  // 在管项目
      }
      if (!this.reginWhere.project_name || this.reginWhere.project_name == '') {
        return false;
      }
      this.loading = true;
      this.tableData = [];
      ButlerHttp.get('LawCase/caseList', {
        project_id: this.reginWhere.project_name,
        case_status: this.searchForm.case_status,
        sue_type: this.searchForm.sue_type,
        is_complete: this.searchForm.is_complete,
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize
      }, res => {
        if (res.code) {
          this.tableData = res.data.list;
          this.pagination.total = res.data.count;
          this.statics = res.data.statics;
          this.$emit('data-loaded', res.data.list);
        }
        this.loading = false;
      })
    },

    onSearch() {
      this.pagination.currentPage = 1;
      this.loadData();
    },

    resetForm() {
      this.searchForm = {
        case_status: '',
        sue_type: '',
        is_complete: ''
      };
      this.onSearch();
    },

    canSelectRow(row) {
      return row.is_complete && row.case_status !== 4;
    },

    tableRowClassName({ row }) {
      if (!row.is_complete) {
        return 'incomplete-row';
      }
      if (row.case_status === 4) {
        return 'closed-row';
      }
      return '';
    },

    getStageType(status) {
      const types = {
        0: 'warning',
        1: 'primary',
        2: 'info',
        3: 'success',
        4: 'default',
        5: 'danger'
      };
      return types[status] || 'default';
    },

    getStageLabel(status) {
      const labels = {
        0: '未提交',
        1: '提交法院',
        2: '调解',
        3: '受理成功',
        4: '回款结案',
        5: '第三方',
        6: '案件执行',
        7: '拒绝受理',
        8: '诉讼保全',
        9: '开庭记录',
        10: '折扣申请',
        11: '上诉申请',
        12: '调解成功',
      };
      return labels[status] || '未知';
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    clearSelection() {
      this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
      this.multipleSelection = [];
    },

    batchOperation(operationType) {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一项');
        return;
      }

      if (!this.canOperate) {
        this.$message.warning('请选择资料完整的案件');
        return;
      }

      let check = true;
      let check_msg = '';

      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (this.multipleSelection[i].case_status == 4) {
          check = false;
          check_msg = '存在已结案的案件，不可操作';
          break;
        }
      }

      if (!check) {
        this.$message.error(check_msg);
        return;
      }

      const operationConfig = {
        submit_court: { title: '提交法院记录', type: 'submit_court' },
        accept: { title: '受理成功', type: 'accept' },
        reject: { title: '拒绝受理', type: 'reject' },
        preservation: { title: '诉讼保全', type: 'preservation' },
        court: { title: '开庭记录', type: 'court' },
        appeal: { title: '上诉申请', type: 'appeal' },
        fill: { title: '诉讼费用申请', type: 'fill' },
        mediation: { title: '调解过程', type: 'mediation' },
        execute: { title: '案件执行', type: 'execute' },
        close: { title: '回款结案', type: 'close' },
        discount : { title : '折扣申请' , type : 'discount' },
        file: { title: '资料盖章', type: 'file' },
      };

      const config = operationConfig[operationType];
      if (!config) return;

      if (operationType === 'file') {
        this.$confirm('确认要发起资料盖章流程吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.submitFileOperation();
        }).catch(() => {
          this.$message.info('已取消操作');
        });
        return;
      }

      if (operationType === 'fill') {
        this.fill.dialog.visible = true;
        this.fill.dialog.title = config.title;
        this.fill.dialog.type = 'fill';
      } else if (operationType === 'execute') {
        this.pay.dialog.visible = true;
        this.pay.dialog.title = config.title;
        this.pay.dialog.type = 'pay';
      } else if (['preservation', 'court', 'appeal', 'mediation'].includes(operationType)) {
        this.flow.dialog.visible = true;
        this.flow.dialog.title = config.title;
        this.flow.dialog.type = operationType;
      } else if (operationType === 'close') {
        // 回款结案：检查所有选中案件的状态是否在允许结案的范围内
        const validStatus = [6, 10, 12]; // 案件执行、折扣申请、调解成功
        const invalidCases = this.multipleSelection.filter(item => {
          return !validStatus.includes(parseInt(item.case_status));
        });

        if (invalidCases.length > 0) {
          this.$message.error('存在状态不在案件执行、折扣申请或调解成功范围内的案件，无法发起结案');
          return;
        }

        this.operationDialog.title = config.title;
        this.operationDialog.type = operationType;
        this.openOperationDialog();
      } else {
        // 提交法院、受理成功、拒绝受理等使用通用操作弹窗
        this.operationDialog.title = config.title;
        this.operationDialog.type = operationType;

        // 如果是提交法院类型，先加载法院列表
        if (operationType === 'submit_court') {
          this.loadCourtList(() => {
            this.openOperationDialog();
          });
        } else {
          this.openOperationDialog();
        }
      }
    },

    loadCourtList(callback) {
      if (this.court_list.length > 0) {
        callback();
        return;
      }
      let house_list = [];
      let project_id = 0;
      this.multipleSelection.forEach(item => {
        house_list.push({
          house_id : item.house_id ,
          customer_id : item.customer_id ,
        });
        project_id = item.project.PrecinctID;
      });

      // 使用与 case_form.vue 相同的接口获取法院列表
      ButlerHttp.post('LawCase/getHouseLegalList', {
        project_id: project_id,
        order_type: 1,
        house_list: house_list
      }, res => {
        if (res.code) {
          this.court_list = res.data.court_list;
        }
        callback();
      });
    },

    openOperationDialog() {
      this.operationDialog.visible = true;
      // 统一使用伸缩面板模式（单案件也使用相同交互）
      this.showMultipleCase = true;

      // 初始化案件列表
      this.operationCaseList = [];
      this.multipleSelection.forEach(item => {
        let cItem = {
          ...item,
          operation_time: new Date().toISOString().slice(0, 19).replace('T', ' '),
          follow_user: '',
          case_no: '',
          remark: '',
          file_list: [],
          court_id: '',
          claims: ''
        };
        this.operationCaseList.push(cItem);
      });
      // 默认展开第一个案件
      this.operationActiveNames = ['0'];
    },

    // 根据操作类型获取 file_key
    getFileKey() {
      const fileKeyMap = {
        'accept': 'accept_file',
        'submit_court': 'submit_court_file',
        'reject': 'reject_file',
        'close': 'close_file',
        'mediation': 'mediation_file'
      };
      return fileKeyMap[this.operationDialog.type] || 'operation_file';
    },

    // 文件上传
    handleCaseUpload(params, caseItem, file_key) {
      let file_name = params.file.name;
      caseJs.uploadFile(params.file, (res) => {
        if (res && res.hasOwnProperty('path')) {
          if (!caseItem.hasOwnProperty('file_list')) {
            caseItem.file_list = [];
          }
          caseItem.file_list.push({
            file_name: file_name,
            file_key: file_key,
            file_url: res.path
          });
        }
      });
    },

    // 多案件模式下的文件删除
    removeCaseFile(caseItem, index) {
      caseItem.file_list.splice(index, 1);
    },

    submitOperation() {
      // 验证每个案件的必填字段
      for (let i = 0; i < this.operationCaseList.length; i++) {
        let item = this.operationCaseList[i];
        if (!item.follow_user) {
          this.$message.error(`第 ${i + 1} 个案件请输入跟进人`);
          return;
        }

        // 受理成功类型：案号/编号、证明文件为必填
        if (this.operationDialog.type === 'accept') {
          if (!item.case_no || item.case_no.trim() === '') {
            this.$message.error(`第 ${i + 1} 个案件请输入案号/编号`);
            return;
          }
          if (!item.file_list || item.file_list.length === 0) {
            this.$message.error(`第 ${i + 1} 个案件请上传证明文件`);
            return;
          }
        }
      }

      this.operationLoading = true;
      // 映射操作类型到 flow_type
      const flowTypeMap = {
        'accept': 'accept',
        'submit_court': 'submit_court',
        'reject': 'reject',
        'close': 'close',
        'mediation': 'mediation'
      };

      const flowType = flowTypeMap[this.operationDialog.type] || this.operationDialog.type;

      const postData = {
        flow_list: this.operationCaseList.map(item => {
          let flowData = {
            operation_time: item.operation_time,
            follow_user: item.follow_user,
            remark: item.remark
          };
          // 根据类型添加特殊字段
          if (this.operationDialog.type === 'accept') {
            flowData.case_no = item.case_no;
          }
          if (this.operationDialog.type === 'submit_court') {
            flowData.court_id = item.court_id;
            flowData.claims = item.claims;
          }
          if(this.operationDialog.type === 'discount'){
            flowData.discount_rate = item.discount_rate;
          }
          return {
            case_id: item.id,
            flow_data: flowData,
            file_list: item.file_list || []
          };
        }),
        flow_type: flowType
      };
      ButlerHttp.post('LawCase/saveFlow', postData, res => {
        this.operationLoading = false;
        if (res.code) {
          this.$message.success('操作成功');
          this.operationDialog.visible = false;
          this.loadData();

          if (this.operationDialog.type === 'accept') {
            const batchNo = res.data.batch_no;
            const amount = this.operationCaseList.reduce((sum, item) => sum + parseFloat(item.legal_money || 0), 0);
            const urlParams = {
              sheet_id: this.project_type === 1 ? '349' : '350',
              master_id: this.project_type === 1 ? '286' : '287',
              timeValue: caseJs.getTimestamp(),
              batch_no: batchNo,
              amount: amount,
              type: '法院受理成功'
            };
            const url = `https://crm.gdzawy.com:9000/#/flow/FlowView?${new URLSearchParams(urlParams).toString()}`;
            // window.open(url);
          } else if (this.operationDialog.type === 'discount') {
            const batchNo = res.data.batch_no;
            const amount = this.operationCaseList.reduce((sum, item) => sum + parseFloat(item.legal_money || 0), 0);
            const minDiscount = Math.min(...this.operationCaseList.map(item => parseFloat(item.discount_rate) || 100));
            const urlParams = {
              sheet_id: '364',
              master_id: '300',
              timeValue: caseJs.getTimestamp(),
              batch_no: batchNo,
              amount: amount,
              type: '折扣申请' ,
              discount : minDiscount,
            };
            const url = `https://crm.gdzawy.com:9000/#/flow/FlowView?${new URLSearchParams(urlParams).toString()}`;
            window.open(url);
          }
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      });
    },

    submitFileOperation() {
      this.operationLoading = true;

      const postData = {
        flow_list: this.multipleSelection.map(item => {
          return {
            case_id: item.id,
            flow_data: {},
            file_list: []
          };
        }),
        flow_type: 'file'
      };

      ButlerHttp.post('LawCase/saveFlow', postData, res => {
        this.operationLoading = false;
        if (res.code) {
          this.$message.success('操作成功');
          this.loadData();

          const batchNo = res.data.batch_no;
          const type = this.project_type === 1 ? '在管' : '撤场';
          const urlParams = {
            sheet_id: '358',
            master_id: '295',
            timeValue: caseJs.getTimestamp(),
            unid: batchNo,
            type: type
          };
          const url = `/#/flow/FlowView?${new URLSearchParams(urlParams).toString()}`;
          window.open(url);
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      });
    },
    onCloseFileDetail() {
      this.loadData();
    },
    onCloseCaseFlow() {
      this.flow.dialog.visible = false;
      this.loadData();
    },
    onCloseCaseFill() {
      this.fill.dialog.visible = false;
      this.loadData();
    },
    onCloseCasePay() {
      this.pay.dialog.visible = false;
      this.loadData();
    },
    onCloseDetail() {
      this.detail.visible = false;
    },

    viewCase(row) {
      this.detail.visible = true;
      this.detail.case_id = row.id;
    },

    showFileDetail(row) {
      this.fileDetailDialog.visible = true;
      this.fileDetailDialog.caseItem = row;
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.loadData();
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadData();
    },

    openImageInNewTab() {
      window.open('/static/staging/case_flow.png', '_blank');
    }
  }
}
</script>

<style scoped>
.case-list-container {
  padding: 20px;
}

.filter-box, .operation-box {
  margin-bottom: 15px;
}

.table-box {
  margin-top: 15px;
}

.box-card {
  margin-bottom: 15px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.search-form .el-form-item {
  margin-right: 20px;
  margin-bottom: 10px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 统计面板样式 */
.statistics-panel {
  margin-bottom: 15px;
}

.statistic-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #EBEEF5;
}

.statistic-row:last-child {
  border-bottom: none;
}

.statistic-label-title {
  width: 80px;
  font-size: 16px;
  font-weight: bold;
  color: #E6A23C;
  text-align: center;
  padding: 12px 0;
}

.statistic-label-title.total {
  color: #67C23A;
}

.statistic-main {
  flex: 1;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.statistic-item {
  text-align: center;
  min-width: 80px;
}

.statistic-number {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 4px;
}

.statistic-label {
  font-size: 12px;
  color: #606266;
}

.statistic-divider {
  width: 1px;
  height: 40px;
  background-color: #DCDFE6;
  margin: 0 15px;
}

.statistic-complete {
  display: flex;
  gap: 30px;
}

/* 操作按钮区域样式 */
.operation-box .box-card {
  padding: 15px;
}

.section-title i {
  margin-right: 8px;
  color: #409EFF;
}

.operation-buttons .el-button {
  min-width: 100px;
}

.selection-count {
  color: #409EFF;
  font-weight: bold;
  margin: 0 4px;
}

.selection-tip i {
  margin-right: 5px;
}

/* 对话框样式 */
.dialog-footer {
  text-align: right;
}

/* 核心单行弹性容器 */
.operation-inline-container {
  display: flex;
  align-items: center; /* 垂直居中 */
  flex-wrap: wrap;     /* 极小屏幕下允许自动换行，防止穿透大屏 */
  gap: 16px;           /* 统一控制元素之间的间距 */
  padding: 8px 0;      /* 增加上下内边距 */
}

/* 分组小标签 */
.inline-group-label {
  font-size: 13px;
  font-weight: bold;
  color: #606266;
  margin-left: 8px;
  padding-right: 4px;   /* 标签与按钮之间增加间距 */
}

/* 将选择计数信息优雅地推到这一行的最右侧 */
.selection-info-inline {
  margin-left: auto;
  font-size: 13px;
  color: #909399;
  white-space: nowrap;
}

.selection-count {
  color: #409EFF;
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_list.vue